export default {
  listCategory: [],
  listProduct: [],
  listAttribute: [],
  accessToken: sessionStorage.getItem('accessToken'),
}
